export default __webpack_public_path__ + "8b0cda934d1fdaca95433099e0204d48.png";